const categories = {
  unSet: 0,
  validForPEI: 1,
  validForPEIOther: 2,
  validForRemedioProvional: 3,
  validForEncuentro: 4,
  validForAppointment: 5,
  validForTriannual: 6,
};

export default categories;
